import {
    get,
    has,
    isObject,
    // clone,
    cloneDeep,
    // forEach,
    set
} from "lodash";
const _ = {
    get,
    has,
    isObject,
    //   clone,
    cloneDeep,
    //   forEach,
    set
};

export const lodashPlugin = {
    install(Vue) {
        Vue.prototype._ = _;
    },
};

export default _;
